import { formatBrlMoney } from '@/lib/functions';
import useProductStore from '@/stores/productStore';

const ReviewPrice = () => {
  const price = useProductStore(d => d.payment.price!);

  return (
    <div className='flex flex-col'>
      <span>Pagamento único</span>
      <span>{formatBrlMoney(price)}</span>
    </div>
  );
};

export default ReviewPrice;
